
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="chartOptions"
      style="width: 100%; height: calc(100% - 40px); display: inline-block;">
    </highcharts-chart>
  